<template>
    <div class="button_parts">
        <h2 class="title is-5">ボタンを押すとカウントアップするボタン</h2>
        <p>ボタンを押すと数字を1つ足すサンプルコードです。</p>
        <b-tag type="is-info">Vue.js</b-tag>
        <hr/>
        <h3 class="title is-5">サンプル</h3>
        <ButtonCountUp/>
        <hr/>
        <p class="title is-5">コード</p>
        <p style="margin-bottom:10px;"><b-button @click="twitterShare" class="is-info" size="is-small"><i class="fab fa-twitter"></i>シェアする</b-button></p>
        <div class="iframely-embed"><div class="iframely-responsive" style="padding-bottom: 56.2493%;"><a href="https://gist.github.com/katonobo/08036bcc6ac1fc9e694b7efe94abb916" data-iframely-url="//cdn.iframe.ly/wrgBxSe"></a></div></div>
    </div>
</template>

<script>
import ButtonCountUp from  '@/components/buttonParts/ButtonCountUp.vue'
export default {
    components:{
        ButtonCountUp
    },
    mounted(){
        const title = "カウントアップのサンプルコード｜あめねこサンプルコード集"
        const description = "Vue.jsで書かれたボタンを押すと数字を1つ足すサンプルコードです。"
        document.title = title
        document.querySelector("meta[property='og:title']").setAttribute('content', title)
        document.querySelector("meta[name='description']").setAttribute('content', description)
        document.querySelector("meta[property='og:description']").setAttribute('content', description)
       
       window.iframely.load();
    },
    methods:{
        twitterShare(){
            var shareURL = 'https://twitter.com/intent/tweet?text=' + "ボタンを押すとカウントアップするボタン" + "%20%23あめねこサンプルコード集" + '&url=' + "https://code.ameneko.com/button-parts-count-up";  
            location.href = shareURL
        }
    }
}
</script>

<style scoped>
.button_parts{
    max-width: 1000px;
    margin:auto;
    padding:10px
}

</style>